import { translation } from '@/plugins/i18n';

export const globalRebrandingMixin = {
  beforeCreate() {
    this.$t = translation;
  }
};

